module.exports = __webpack_public_path__ + "static/media/files icon-PPT.0ecb3090.png";